import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import './JobBearbeiten.css';

function JobBearbeiten() {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [formData, setFormData] = useState({
    Name: '',
    Beschreibung: '',
    Ueberstunden: false,
    Ganztagesjob: false,
    Mindestanzahl: 2,
    Handwerksjob: false
  });

  useEffect(() => {
    fetch(`${host_url}/jobs`)
      .then(response => response.json())
      .then(data => {
        const sortedJobs = data.sort((a, b) => a.Name.localeCompare(b.Name));
        setJobs(sortedJobs);
      });
  }, []);

  const handleJobSelect = (e) => {
    const jobIDString = e.target.value;
    if (jobIDString === "") { // Handle "Wähle einen Job aus"
      setSelectedJob(null);
      setFormData({
        Name: '',
        Beschreibung: '',
        Ueberstunden: false,
        Ganztagesjob: false,
        Mindestanzahl: 2,
        Handwerksjob: false
      });
      return;
    }
    const jobID = Number(jobIDString);
    const selected = jobs.find(j => j.JobID === jobID);
    if (selected) {
      setSelectedJob(selected);
      setFormData({
        Name: selected.Name,
        Beschreibung: selected.Beschreibung,
        Ueberstunden: selected.Ueberstunden,
        Ganztagesjob: selected.Ganztagesjob,
        Mindestanzahl: selected.Mindestanzahl !== undefined ? selected.Mindestanzahl : 2,
        Handwerksjob: selected.Handwerksjob || false
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = () => {
    if (!selectedJob) {
      alert("Bitte zuerst einen Job auswählen.");
      return;
    }
    fetch(`${host_url}/jobs`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...formData, JobID: selectedJob.JobID })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setSuccessMsg('Job erfolgreich aktualisiert');
        const currentSelectedJobId = selectedJob.JobID; // Store ID before refetch
        // Refetch jobs to update the dropdown and local state
        fetch(`${host_url}/jobs`)
          .then(response => response.json())
          .then(updatedJobsData => {
            const sortedJobs = updatedJobsData.sort((a, b) => a.Name.localeCompare(b.Name));
            setJobs(sortedJobs);
            // Re-select the job to update its details in the form and ensure dropdown consistency
            const newlyUpdatedJob = sortedJobs.find(job => job.JobID === currentSelectedJobId);
            if (newlyUpdatedJob) {
              setSelectedJob(newlyUpdatedJob); // This updates selectedJob state
              setFormData({ // Also update formData to reflect the latest state
                Name: newlyUpdatedJob.Name,
                Beschreibung: newlyUpdatedJob.Beschreibung,
                Ueberstunden: newlyUpdatedJob.Ueberstunden,
                Ganztagesjob: newlyUpdatedJob.Ganztagesjob,
                Mindestanzahl: newlyUpdatedJob.Mindestanzahl !== undefined ? newlyUpdatedJob.Mindestanzahl : 2,
                Handwerksjob: newlyUpdatedJob.Handwerksjob || false
              });
            } else {
              // Should not happen if update was successful, but as a fallback:
              setSelectedJob(null);
              setFormData({ Name: '', Beschreibung: '', Ueberstunden: false, Ganztagesjob: false, Mindestanzahl: 2, Handwerksjob: false });
            }
          })
          .catch(error => {
            console.error("Fehler beim Neuladen der Jobs:", error);
            alert("Job aktualisiert, aber Fehler beim Neuladen der Jobliste.");
          });
      } else {
        alert('Fehler beim Aktualisieren des Jobs: ' + (data.message || 'Unbekannter Fehler'));
      }
    })
    .catch(error => {
        console.error("Fehler beim Senden der Jobaktualisierung:", error);
        alert("Netzwerkfehler oder Server nicht erreichbar beim Aktualisieren des Jobs.");
    });;
  };

  const handleDeleteJob = () => {
    if (!selectedJob) {
      alert("Bitte zuerst einen Job auswählen.");
      return;
    }

    // Sicherheitsabfrage vor dem Löschen
    if (!window.confirm(`Möchtest du den Job "${selectedJob.Name}" wirklich löschen?`)) {
      return;
    }

    fetch(`${host_url}/jobs/${selectedJob.JobID}`, {
      method: 'DELETE',
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setSuccessMsg('Job erfolgreich gelöscht');
        // Jobliste neu laden und Formular zurücksetzen
        fetch(`${host_url}/jobs`)
          .then(response => response.json())
          .then(updatedJobsData => {
            const sortedJobs = updatedJobsData.sort((a, b) => a.Name.localeCompare(b.Name));
            setJobs(sortedJobs);
            setSelectedJob(null);
            setFormData({ Name: '', Beschreibung: '', Ueberstunden: false, Ganztagesjob: false, Mindestanzahl: 2, Handwerksjob: false });
          });
      } else {
        alert('Fehler beim Löschen des Jobs: ' + (data.message || data.error || 'Unbekannter Fehler'));
      }
    })
    .catch(error => alert('Netzwerkfehler oder Server nicht erreichbar beim Löschen des Jobs.'));
  };

  return (

    <KernteamLayout>
    <div className="container">
      <BackArrow to="/arbeit" />
      <h1 className="section-title orange">Job bearbeiten</h1>
      <main>
      <div className="job-select">
        <h3>Job</h3>
        <div className={`dropdown-wrapper ${selectedJob ? 'filled' : ''}`}>
          <select onChange={handleJobSelect} value={selectedJob ? selectedJob.JobID : ''}>
            <option value="" disabled>Wähle einen Job</option>
            {jobs.map(job => (
              <option key={job.JobID} value={job.JobID}>{job.Name}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
      </div>
      {selectedJob && (
        <div className="job-form">
          <div className="form-group">
            <label>
              Name
              <input type="text" name="Name" value={formData.Name} onChange={handleChange} />
            </label>
          </div>
          <div className="form-group">
            <label>
              Beschreibung
              <textarea name="Beschreibung" value={formData.Beschreibung} onChange={handleChange} />
            </label>
          </div>
          <div className="form-group">
            <label className="checkbox-green">
              <input type="checkbox" name="Ueberstunden" checked={formData.Ueberstunden} onChange={handleChange} />
              Überstunden
            </label>
          </div>
          <div className="form-group">
            <label className="checkbox-green">
              <input type="checkbox" name="Ganztagesjob" checked={formData.Ganztagesjob} onChange={handleChange} />
              Ganztagesjob
            </label>
          </div>
          <div className="form-group">
            <label className="checkbox-green">
              <input type="checkbox" name="Handwerksjob" checked={formData.Handwerksjob} onChange={handleChange} />
              Handwerksjob
            </label>
          </div>
          <div className="form-group">
            <label>
              Mindestanzahl Slots
              <input type="number" min="0" name="Mindestanzahl" value={formData.Mindestanzahl} onChange={handleChange} />
            </label>
          </div>
          <div className="jb-map-container">
            <a
              href={
                selectedJob
                  ? `/jobsmarkieren?jobID=${selectedJob.JobID}`
                  : '/jobsmarkieren'
              }
              target="_blank"
              rel="noopener noreferrer"
              className="jb-map-link"
            >
              <span className="material-symbols-outlined jb-map-icon">add_location</span>
              <span className="jb-map-label">Auf Karte markieren</span>
            </a>
          </div>
          <div className="actions">
          <button onClick={handleSubmit}>Änderungen speichern</button>
            <div className="delete-link" onClick={handleDeleteJob}>
              <span className="material-symbols-outlined delete-icon">delete</span>
              <span className="delete-label">Job löschen</span>
            </div>
          </div>
        </div>
      )}
      </main>
    </div>
    <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default JobBearbeiten;